/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 3800 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Munu & Moti",
  title: "Lean systems - Powerful outcomes",
  subTitle: "Building compounding advantage through intelligent infrastructure."
  ,
  //resumeLink:
  //  "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  gmail: "contact@munuandmoti.tech",
  //facebook: "https://www.facebook.com/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: false // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "About Us",
  subTitle: "OUR FIVE INTERNAL CORE SERVICES ",
  skills: [
    emoji(
      "⚡ Prashasaka - Admin automation for invoices, contracts, scheduling, expenses, HR, and compliance."
    ),
    emoji("⚡ Saayaka - Support workflow automation for inquiries, ticket routing, scheduling, and dispatch. "),
    emoji(
      "⚡ Vipanana - Marketing and outreach automation for content, prospecting, monitoring, and grant drafting."
    ),
    emoji("⚡ Khandasrinkhala Lekhapariksaka - Blockchain security auditing for smart contracts, on-chain risks, and compliance checks. "),
    emoji("⚡ Vitta-Vanijyika - Treasury and proprietary trading through algorithmic strategies and risk controls. "),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
   
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Mayank Sahoo",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Founder and Chief Executive Officer",
      duration: "BEng Mechanical Engineering, University of Sheffield, UK",
      //desc: "Base Locations: Noida, India and Ranchi, India (GST operational wings of Munu & MotiTM India operations)",
      descBullets: [
        "Mayank Sahoo is the company’s strategic leader, responsible for overall direction, external relations, defense-vertical leadership, and group-level growth coordination.",
        "His skills span mechanical engineering, blockchain and algorithmic trading systems, AI/LLM and agentic AI architecture, MLOps, robotics software, and business leadership in regulation, fundraising, investor relations, and team building."
      ]
    },
    {
      schoolName: "Muskaan Sharma",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Chief Technology Officer",
      duration: "BTech Information Technology, KIIT University, Bhubaneswar, Odisha, India",
      //desc: "Base Locations: Noida, India and Ranchi, India",
      descBullets: ["Muskaan Sharma is responsible for leading the AI and Robotics Labs, proprietary model development, and the engineering stack.",
        "Her strengths span AI/ML, LLM fine-tuning, cloud infrastructure, MLOps, software engineering, DevSecOps, and technical team leadership."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Quarter 1", //Insert stack or technology you have experience in
      progressPercentage: "0%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Quarter 2",
      progressPercentage: "0%"
    },
    {
      Stack: "Quarter 3",
      progressPercentage: "0%"
    },
    {
      Stack: "Quarter 4",
      progressPercentage: "0%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "# of openings : 1",
      company: "Chief Financial Officer",
      //companylogo: require("./assets/images/facebookLogo.png"),
      date: "Hiring 2027 onwards",
      desc: "Job specifications:",
      descBullets: [
        "This role leads financial planning, treasury, and the company’s overall finance structure.",
        "It requires ax and finance expertise and experience with holding-company structures."
      ]
    },
    {
      role: "# of openings : 1",
      company: "Independent Director",
      //companylogo: require("./assets/images/quoraLogo.png"),
      date: "Hiring 2027 onwards",
      desc: "Job specifications:",
      descBullets: ["This role provides strategic oversight and external business guidance at board level.",
      " It requires a business background with fintech or AI experience."
    ]
    },
    {
      role: "# of openings : 1",
      company: "Independent Director",
      //companylogo: require("./assets/images/quoraLogo.png"),
      date: "Hiring 2027 onwards",
      desc: "Job specifications:",
      descBullets: ["This role provides academic and research guidance at board level.",
      "It requires University faculty-level expertise in AI or quantum computing."
    ]
    },
    {
      role: "# of openings : 1",
      company: "Finance and Operations Manager",
      //companylogo: require("./assets/images/quoraLogo.png"),
      date: "Hiring 2027 onwards",
      desc: "Job specifications:",
      descBullets: ["This role manages finance, operations, compliance coordination, and internal administration as the company scales.",
      " It requires expertise in business operations, finance, compliance, and administrative management."
    ]
    },
    {
      role: "# of openings : 2",
      company: "Senior AI/ML Engineer",
      //companylogo: require("./assets/images/quoraLogo.png"),
      date: "Hiring 2027 onwards",
      desc: "Job specifications:",
      descBullets: ["This role builds and deploys proprietary AI models and supports the AI Lab’s core systems.",
      "It requires expertise in AI/ML, LLM fine-tuning, MLOps, cloud deployment, and Python-based software engineering."
    ]
    },
    {
      role: "# of openings : 2",
      company: "Simulation/Robotics Engineer",
      //companylogo: require("./assets/images/quoraLogo.png"),
      date: "Hiring 2027 onwards",
      desc: "Job specifications:",
      descBullets: ["This role develops robotics workflows, simulation-to-real systems, and automation for manufacturing and inspection. ",
      "It requires expertise in ROS2, Gazebo, MoveIt2, OpenCV, SLAM, and engineering simulation tools."
    ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Our Labs",
  subtitle: " Munu & Moti AI Labs and Munu & Moti Robotics Lab. Both are centralized internal capabilities designed to support all subsidiaries rather than operate as standalone commercial services.",
  projects: [
    {
      //image: require("./assets/images/saayaHealthLogo.webp"),
      image: require("./assets/images/AI_Labs.png"),
      video: require("./assets/videos/AI_Labs.mp4"),
      projectName: "Munu & Moti AI Labs",
      projectDesc: "A centralized agentic AI and R&D lab that develops proprietary models, simulation pipelines, and automation systems for use across the group.",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "http://saayahealth.com/"
      //   }
      //   //  you can add extra buttons here.
      // ]
    },
    {
      image: require("./assets/images/Robotics_Lab.png"),
      video: require("./assets/videos/Robotics_Lab.mp4"),
      projectName: "Munu & Moti Robotics Lab",
      projectDesc: "A robotics research lab focused on autonomous systems, hardware-software integration, prototype testing, and manufacturing-related automation.",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "http://nextu.se/"
      //   }
      // ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Our Subsidiaries",
  subtitle:
    "The Astrakaraka subsidiaries cover commercial defense technology, product manufacturing, and European sales and marketing operations.",

  achievementsCards: [
    {
      title: "Astrakaraka Technologies Ltd",
      subtitle:
        "The core commercial subsidiary focused on defense and critical infrastructure technology.",
      //image: require("./assets/images/codeInLogo.webp"),
      image: require("./assets/images/astra1.png"),
      //imageAlt: "Google Code-In Logo",
      // footerLink: [
      //   {
      //     name: "Certification",
      //     url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
      //   },
      //   {
      //     name: "Award Letter",
      //     url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
      //   },
      //   {
      //     name: "Google Code-in Blog",
      //     url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
      //   }
      // ]
    },
    {
      title: "Astrakaraka Defense Systems",
      subtitle:
        "The production-oriented subsidiary responsible for physical manufacturing of Astrakaraka products.",
      //image: require("./assets/images/googleAssistantLogo.webp"),
      image: require("./assets/images/astra2.png"),
      //imageAlt: "Google Assistant Action Logo",
      // footerLink: [
      //   {
      //     name: "View Google Assistant Action",
      //     url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
      //   }
      // ]
    },

    {
      title: "Astrakaraka EU Marketing",
      subtitle: "The sales and market-facing subsidiary handling Astrakaraka’s marketing and commercial operations in Europe.",
      // image: require("./assets/images/pwaLogo.webp"),
      image: require("./assets/images/astra3.png"),
      // imageAlt: "PWA Logo",
      // footerLink: [
      //   {name: "Certification", url: ""},
      //   {
      //     name: "Final Project",
      //     url: "https://pakistan-olx-1.firebaseapp.com/"
      //   }
      // ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Media",
  subtitle:
    "Exploring the intersection of code, hardware, and the future.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://www.researchgate.net/publication/348112776_ULNAR_INTERCALARY_HEMIMELIA_WITH_MULTIPLE_EXOSTOSES_A_RARE_CASE_REPORT",
      title: "Ulnar Intercalary Hemimelia With Multiple Exostoses: A Rare Case Report",
      description:
        "Isidore Geoffroy Saint-Hilaire coined the term “hemimelia” in the early 19th century, while in 1951, O'Rahilly suggested the term “paraxial hemimelia” for the longitudinal variety, because either the preaxial or postaxial side of the limb is involved.The deficiency can be transverse, longitudinal and sometimes combination of both. This case report highlights the finding of a case of ulnar intercalary hemimelia with multiple bilateral exostoses of the knee and the rehabilitation potential for the same."
    },
    {
      url: "https://www.researchgate.net/publication/338492453_Association_between_MATN-3_Gene_Polymorphism_and_Primary_Knee_Osteoarthritis_in_Indian_Population_A_Community-Based_Case-Control_Study",
      title: "Association between MATN-3 Gene Polymorphism and Primary Knee Osteoarthritis in Indian Population: A Community-Based Case-Control Study ",
      description:
        "The verdicts obtained from the present study proposed that MATN-3 gene polymorphism was not associated with primary knee osteoarthritis in the Indian population."
    },
    {
      url: "https://www.researchgate.net/publication/339877116_Comparative_study_between_closed_reduction_and_cast_application_with_and_without_percutaneous_K-wire_fixation_for_extra_articular_fracture_distal_end_radius",
      title: "Comparative study between closed reduction and cast application with and without percutaneous K-wire fixation for extra articular fracture distal end radius",
      description:
        "Closed reduction and cast application and closed reduction with percutaneous k-wire fixation both treatment can be done as there is no superiority of one treatment over the other."
    },
    {
      url: "https://www.researchgate.net/publication/339023658_Radiological_and_clinical_outcome_of_conservative_management_of_thoracolumbar_spinal_tuberculosis_in_adults",
      title: "Radiological and clinical outcome of conservative management of thoracolumbar spinal tuberculosis in adults",
      description:
        "MRI gains the role of a pivoting stone in non-invasively diagnosing spinal tuberculosis as the gold standard investigation. The old regime of 18 months of ATT is not valid nowadays and just a meticulously applied 6-12 months of ATT is sufficient to achieve cure of spinal tuberculosis. Judiciously applied conservative management may certainly give exceedingly good results."
    },
    {
      url: "https://www.researchgate.net/publication/338392009_AN_UNUSUAL_CASE_OF_ATLANTO_AXIAL_INSTABLITY_IN_A_PATIENT_OF_SKELETAL_DYSPLASIA_WITH_BILATERAL_TOTAL_HIP_REPLACEMENT_SUGGESTING_NEED_FOR_CAREFUL_SPINE_EVALUATION",
      title: "An Unusual Case Of Atlanto Axial Instability In A Patient Of Skeletal Dysplasia With Bilateral Total Hip Replacement, Suggesting Need For Careful Spine Evaluation",
      description:
        "Skeletal dysplasia's are a heterogeneous group of disorders that have in common a defect in bone formation or remodeling, thus leading to abnormal biomechanics and various spinal and joint manifestations. A 25 year old female presented to us..."
    },
    {
      url: "https://www.researchgate.net/publication/337859338_Morphological_and_mechanical_properties_of_bone_tissues",
      title: "Morphological and mechanical properties of bone tissues",
      description:
        "Adult human skeletal system consists of 206 bones and this system gives the human body its shape, supports it, and helps in movements. These bones are made of living bones tissues which replenish throughout the lifetime of an individual. There are different bone diseases associated to these bone tissues like osteoporosis, low bone density, osteogenesis imperfecta, and Paget’s disease of bones which happen when these bone tissues..."
    },
    {
      url: "https://www.researchgate.net/publication/343510329_Multiple_Nora_Lesions_A_Rare_Case_Report",
      title: "Multiple Nora Lesions: A Rare Case Report",
      description:
        "Bizarre parosteal osteochondromatous proliferation (BPOP), rst described by Nora et al. in 1983. It is a rare lesion that occurs in the short  bones of the hands and feet and eventually presents as a parosteal mass [1,2]. BPOP does not become malignant..."
    },
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Us ☎️"),
  subtitle:
    "Drop Us a Line",
  //number: "+91-9199201696",
  email_address: "contact@munuandmoti.tech"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
